export default __webpack_public_path__ + "static/media/salon.fd36a971.svg";